import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import router from './router'
import App from './App.vue'
import './style.css'
import { useAuth } from './composables/auth/useAuth'

const app = createApp(App)

app.use(createPinia())
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 30, // 30 minutes
        retry: 3,
        retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000)
      }
    }
  }
})
// Restore the server-side session before installing the router. Vue Router
// starts its initial navigation when installed, so installing it first would
// let the auth guard see an empty in-memory state after a page reload.
const { initAuth } = useAuth()

initAuth()
  .catch(err => {
    console.warn('Failed to restore auth session:', err)
  })
  .finally(() => {
    app.use(router)
    app.mount('#app')
  })
